<template>
  <div class="info-container">
    <!-- 检查对应的设备是否完成实名认证 -->
    <div v-if="!isFinshAuth" class="auth-tip">
      <div class="auth-left">
        <div class="left-img">
          <van-icon name="fail" color="var(--primary-color)" size="14" />
        </div>
        <p class="left-text">{{ isFinshMessage }}</p>
      </div>

      <div class="auth-right" @click="enterAuth">
        <p class="right-text">前往</p>
        <van-icon
          class="enter-infor-right-icon"
          name="arrow"
          size="16"
          color="var(--primary-color)"
        ></van-icon>
      </div>
    </div>

    <!-- 用户信息 -->
    <div class="user-info-container" @click="enterCenterAction">
      <img
        class="user-head"
        :src="
          userHead ? userHead : require('@/assets/images/home/userHead.png')
        "
      />

      <div class="user-info">{{ userName || "微信昵称" }}</div>

      <img
        class="user-info-right-icon"
        :src="require('@/assets/images/home/rightIcon.png')"
      />
    </div>

    <!-- 分割线 -->
    <div class="user-info-line"></div>

    <!-- 判断是否有设备 -->
    <div v-if="userType === 1">
      <!-- 有设备 -->
      <div class="enter-infor">
        <div class="enter-infor-content">
          <img
            class="enter-infor-image"
            :src="
              devicePicUrl
                ? devicePicUrl
                : require('@/assets/images/home/device.png')
            "
          />
        </div>

        <div class="enter-infor-text">
          <div class="enter-infor-text-item">
            <p class="enter-infor-text-item-title">{{ deviceName }}</p>
            <div
              v-if="deviceStatus.length"
              class="enter-infor-text-item-status-container"
              :style="{ backgroundColor: statusColor + '1A' }"
            >
              <div
                class="enter-infor-color-block"
                :style="{ backgroundColor: statusColor }"
              ></div>
              <p
                class="enter-infor-text-item-status"
                :style="{
                  color: statusColor,
                  backgroundColor: statusColor + '1A',
                }"
              >
                {{ deviceStatus }}
              </p>
            </div>
          </div>
          <p class="enter-infor-text-item-number">{{ deviceSN }}</p>
        </div>

        <div class="enter-infor-manger" @click="enterInfor">
          <p>设备信息</p>
          <van-icon
            class="enter-infor-right-icon"
            name="arrow"
            size="16"
            color="var(--primary-color)"
          ></van-icon>
        </div>
      </div>
    </div>

    <div v-else>
      <!-- 没有设备 -->
      <div class="no-device-container" @click="enterAddDevice">
        <div class="add-device-place">
          <van-icon
            color="#fff"
            size="12px"
            name="plus"
            style="font-weight: bold"
          />
        </div>
        <p class="no-device-text">添加设备</p>
      </div>
    </div>

    <!-- 设备状态信息 -->
    <div class="item-container">
      <div class="item" v-for="(item, index) in items" :key="index">
        <p
          class="item-top-title"
          :style="{
            color:
              index === 0 && item.top === '离线'
                ? '#999999'
                : 'var(--primary-color)',
          }"
        >
          {{ item.top }}
        </p>
        <p class="item-bottom-title">
          {{ item.bottom }}
        </p>
      </div>
    </div>

    <!-- 分隔块 -->
    <div class="color-block"></div>

    <!-- 流量统计部分 -->
    <div class="traffic-statistics-content">
      <div class="traffic-color-block"></div>

      <p class="traffic-statistics-title">流量统计</p>
      <p class="traffic-statistics-time" v-if="userType !== 0">
        统计截止：{{ statisticsEndTime }}
      </p>
      <div
        v-if="userType !== 0"
        class="traffic-icon"
        @click="getFlowInfoAction(true)"
      >
        <van-icon
          name="replay"
          size="14px"
          style="font-weight: bold"
          color="var(--primary-color)"
        />
      </div>
    </div>

    <div
      class="traffic-package-container"
      :class="{ 'bottom-spacing': userType === 0 }"
    >
      <!-- 首页流量图 -->
      <traffic-charts
        :total="total"
        :surplus="surplus"
        :planName="chartTitle"
        :percent="usedTrafficPercent"
        :tpIsNormal="tpIsNormal"
        :isUpgradeFlag="isUpgradeFlag"
        @upgrade-click="handleUpgrade"
      ></traffic-charts>
    </div>

    <div v-if="userType !== 0" @click="goUseList">
      <p class="traffic-package-title">使用记录</p>
    </div>

    <!-- 套餐信息 -->
    <div class="traffic-package-info-container">
      <div
        class="traffic-package-info-item"
        v-for="(item, index) in trafficPackageList"
        :key="index"
      >
        <p
          class="traffic-package-info-item-value"
          :style="
            index === trafficPackageList.length - 1 && usedTrafficPercent >= 80
              ? 'color: #ff3831'
              : ''
          "
        >
          {{ item.value }}
          <span style="font-size: 14px; font-weight: normal">
            {{ item.place }}
          </span>
        </p>

        <p class="traffic-package-info-item-title">{{ item.title }}</p>
      </div>
    </div>

    <!-- 购买按钮区域 -->
    <template v-if="userType === 0 || tpIsNormal == 0">
      <div v-if="isAuth" class="traffic-conent">
        <button class="package-one-left" @click="goInternetAuth">
          上网认证
        </button>
        <button class="package-one-right" @click="firstBuyTrafficPackage">
          {{ tpIsNormal == 0 ? "立即购买" : "购买流量套餐" }}
        </button>
      </div>
      <button
        v-else
        class="traffic-package-buy-button"
        @click="firstBuyTrafficPackage"
      >
        {{ tpIsNormal == 0 ? "立即购买" : "购买流量套餐" }}
      </button>
    </template>

    <template v-else>
      <div v-if="orderType === 'L'">
        <div v-if="isAuth" class="traffic-conent">
          <button class="package-one-left" @click="goInternetAuth">
            上网认证
          </button>
          <button class="package-one-right" @click="firstBuyTrafficPackage">
            购买流量套餐
          </button>
        </div>
        <button v-else class="log-buy-button" @click="firstBuyTrafficPackage">
          购买流量套餐
        </button>
      </div>

      <div v-else>
        <!-- 套餐到期时间 -->
        <div class="traffic-time-container" :class="{ 'has-auth': isAuth }">
          <div v-if="isAuth" class="traffic-package-conent">
            <button class="traffic-package-auth-button" @click="goInternetAuth">
              上网认证
            </button>
            <button
              class="traffic-package-expire-time-button"
              @click="buyTrafficPackage"
            >
              {{ isExpired ? "立即购买" : "立即续费" }}
            </button>
          </div>

          <div class="traffic-package-expire-time-content">
            <p class="traffic-package-expire-time-title">
              <span v-if="isExpired">
                套餐已于
                <span style="color: #ff3831">{{ packageInvalidDate }}</span
                ><span style="margin-left: 2px">到期，请尽快续费</span>
              </span>
              <span v-else>
                套餐于
                <span style="color: #ff3831">{{ packageInvalidDate }}</span
                ><span>日到期，剩余</span
                ><span style="color: #ff3831">{{ remainDays }}</span
                ><span>天</span>
              </span>
            </p>
          </div>

          <button
            v-if="!isAuth"
            class="traffic-package-button"
            @click="buyTrafficPackage"
          >
            {{ isExpired ? "立即购买" : "立即续费" }}
          </button>
        </div>
      </div>
    </template>

    <!-- Banner轮播 -->
    <template v-if="bannerList.length">
      <div class="banner-wrapper">
        <van-swipe class="banner-swipe" autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="(item, index) in bannerList" :key="index">
            <img
              class="banner-image"
              :src="
                item.pic.length > 0
                  ? item.pic
                  : require('@/assets/images/home/banner.png')
              "
            />
          </van-swipe-item>
        </van-swipe>
      </div>
    </template>
  </div>
</template>

<script>
import trafficCharts from "@/components/traffic-charts/index";
import { Toast } from "vant";

import {
  getBanner,
  getUserInfo,
  getDeviceInfoById,
  getUserDeviceList,
  getDeviceAuthInfo,
  getFlowInfo,
} from "@/api/home";

import { formatDate, getDeviceStatusInfo } from "../../utils/deviceUtils";

export default {
  components: {
    trafficCharts,
  },
  data() {
    return {
      // 用户信息
      userName: "",
      userHead: "",
      // 是否存在设备 0-不存在 1-存在
      userType: 0,

      // 流量统计
      surplus: 0,
      total: 0,
      chartTitle: "暂无流量套餐",
      usedTrafficPercent: 0, // 当日/当月已使用流量百分比，单位%

      // 流量到期信息
      packageInvalidDate: "",
      remainDays: "",
      isExpired: false,

      // 设备信息
      deviceList: [],
      deviceID: "",
      deviceSN: "",
      devicePicUrl: "",
      deviceName: "",
      deviceStatus: "",
      selectedDeviceId: "",

      // 流量统计截止时间
      statisticsEndTime: "",

      // 套餐状态
      tpIsNormal: 1, // 当前机具套餐是否正常使用 0-否,1-是
      orderType: "", // 套餐是否长期

      // 加载状态
      isLoading: false,

      // 设备状态项
      items: [
        { top: "--", bottom: "在线状态" },
        { top: "--", bottom: "信号强度" },
        { top: "--", bottom: "剩余电量" },
        { top: "--", bottom: "连接设备" },
      ],

      // 流量套餐信息
      trafficPackageList: [
        {
          title: "套餐周期",
          value: "--",
          place: "",
        },
        {
          title: "单日总量",
          value: "--",
          place: "",
        },
        {
          title: "当日剩余",
          value: "--",
          place: "",
        },
      ],

      // Banner列表
      bannerList: [],

      // 认证状态
      isFinshAuth: true, // 是否完成实名认证
      isFinshMessage: "", // 实名认证提示文字
      isAuth: false, // 是否需要上网认证

      packageId: "", //需要升级的套餐id
      isUpgradeFlag: 0, //是否能套餐升级，0否，1是
    };
  },

  computed: {
    statusColor() {
      return this.deviceStatus === "初始" || this.deviceStatus === "正常"
        ? "#0FB176"
        : "#D81E06";
    },
  },

  mounted() {
    // 接受外部SN
    this.deviceSN = this.$route.query.sn;
    // 获取用户信息
    this.getUserInfoAction();
    // 获取banner
    this.getBannerAction();
  },

  methods: {
    handleUpgrade() {
      this.uni.navigateTo(
        "/home/updateBuyOrder?packageId=" +
          this.packageId +
          "&terminalId=" +
          this.deviceID +
          "&isHelpOtherPurchase=0" +
          "&sn=" +
          this.deviceSN,
      );
    },

    // 获取用户信息
    getUserInfoAction() {
      getUserInfo().then((res) => {
        this.userName = res.name;
        this.userHead = res.avatar;
        this.getUserDeviceListAction();
      });
    },

    // 获取用户设备列表
    getUserDeviceListAction() {
      getUserDeviceList()
        .then((res) => {
          // 转换设备列表数据
          this.deviceList = res.map((item) => ({
            id: item.id,
            modelName: item.modelName,
            sn: item.sn,
            picUrl: item.picUrl,
          }));

          // 设置用户类型 - 有设备为1，无设备为0
          this.userType = this.deviceList.length > 0 ? 1 : 0;

          if (this.deviceList.length > 0) {
            // 处理设备ID
            const savedDeviceID = this.$store.getters.getDeviceID;

            let selectDevice;

            if (this.deviceSN) {
              selectDevice = this.deviceList.find(
                (device) => device.sn === this.deviceSN,
              );
            } else {
              selectDevice = this.deviceList.find(
                (device) => device.id === savedDeviceID,
              );
            }

            if (!selectDevice) {
              selectDevice = this.deviceList[0];
            }

            this.deviceID = selectDevice.id;
            this.selectedDeviceId = this.deviceID;
            this.deviceSN = selectDevice.sn;
            this.deviceName = selectDevice.modelName;
            this.devicePicUrl = selectDevice.picUrl;

            // 保存当前选中的设备ID
            this.$store.commit("setDeviceID", this.deviceID);

            // 获取当前设备的详细信息
            this.getDeviceInfoByIdAction();
            // 获取流量信息
            this.getFlowInfoAction(true);
            // 获取卡的认证状态
            this.getDeviceAuthInfoAction();
          } else {
            this.deviceID = "";
            this.selectedDeviceId = "";
            this.devicePicUrl = "";
            this.$store.commit("setDeviceID", "");
          }
        })
        .catch((error) => {
          this.deviceList = [];
          this.userType = 0;
          this.deviceID = "";
          this.selectedDeviceId = "";
          this.devicePicUrl = "";
        });
    },

    // 获取设备认证信息
    getDeviceAuthInfoAction() {
      getDeviceAuthInfo({
        sn: this.deviceSN,
      }).then((res) => {
        const ispNetworkList = res.ispNetwork || [];

        const ispMap = {
          T: "电信",
          M: "移动",
          U: "联通",
        };

        // 找出未认证的运营商
        const unCertifyIspNames = ispNetworkList
          .filter((item) => item.certifyState === 0)
          .map((item) => ispMap[item.isp] || "未知运营商");

        if (unCertifyIspNames.length > 0) {
          // 有未认证的，组合提示文字
          const tips = `(${unCertifyIspNames.join("/")})运营商实名登记未完成`;
          this.isFinshMessage = tips;
          this.isFinshAuth = false;
        } else {
          this.isFinshAuth = true;
        }
      });
    },

    // 获取设备信息
    getDeviceInfoByIdAction() {
      getDeviceInfoById({
        id: this.deviceID,
      }).then((res) => {
        ///上网认证是否展示入口(true展示)
        this.isAuth = res.wirelessIsShow;

        // 使用工具函数处理设备状态
        const statusInfo = getDeviceStatusInfo(res);
        this.deviceStatus = statusInfo.deviceStatus;

        this.items = [
          { top: statusInfo.onlineStatus, bottom: "在线状态" },
          { top: statusInfo.signalStrength, bottom: "信号强度" },
          { top: statusInfo.batteryStatus, bottom: "剩余电量" },
          { top: statusInfo.connectedDevices, bottom: "连接设备" },
        ];
      });
    },

    // 获取流量信息
    getFlowInfoAction(flage) {
      if (!this.deviceID) {
        return;
      }
      if (flage) {
        this.isLoading = true;
        Toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
      }

      getFlowInfo({
        id: this.deviceID,
      })
        .then((res) => {
          const resData = res || {};

          ///需要升级的套餐id
          this.packageId = resData.packageId;
          ///是否能套餐升级，0否，1是
          this.isUpgradeFlag = resData.isUpgradeFlag;

          // 当前机具套餐是否正常使用 0-否,1-是
          this.tpIsNormal = resData.tpIsNormal;

          if (this.tpIsNormal === 0) {
            this.trafficPackageList = [
              {
                title: "套餐总量",
                value: "--",
                place: "",
              },
              {
                title: "套餐剩余",
                value: "--",
                place: "",
              },
            ];

            this.surplus = 0;
            this.total = 0;
            this.usedTrafficPercent = 0;
            this.statisticsEndTime = resData.statisticTime
              ? formatDate(resData.statisticTime)
              : "";
            this.chartTitle = "";
          } else {
            // 容错处理 key 缺失
            this.statisticsEndTime = resData.statisticTime
              ? formatDate(resData.statisticTime)
              : "";

            this.surplus = parseFloat(resData.remainTraffic || "0");
            if (this.surplus < 0) this.surplus = 0;

            this.total = parseFloat(resData.totalTraffic || "0");
            this.usedTrafficPercent = parseFloat(
              resData.usedTrafficPercent || "0",
            );
            this.chartTitle = resData.packageName || "暂无流量套餐";
            this.packageInvalidDate = formatDate(resData.packageInvalidDate);
            this.remainDays = resData.packageRemainDays;
            this.isExpired = this.remainDays > 0 ? false : true;

            let type = resData.packageCycleUnit || "";
            let typeValue = resData.packageCycleValue || 0;

            let replace = "";
            let centerReplace = "";

            if (type === "M") {
              type = "月";
              replace = "个月";
              centerReplace = "月";
            } else if (type === "D") {
              type = "天";
              replace = "天";
              centerReplace = "日";
            } else if (type === "L") {
              // 永久套餐
              this.trafficPackageList = [
                {
                  title: "总量",
                  value: resData.totalTraffic || "0",
                  place: "GB",
                },
                {
                  title: "剩余",
                  value: resData.remainTraffic || "0",
                  place: "GB",
                },
              ];
              this.orderType = "L";
              return; // 提前结束
            } else {
              type = "天";
              typeValue = "-";
              replace = "";
              centerReplace = "日";
            }

            this.orderType = "";
            this.trafficPackageList = [
              {
                title: "套餐周期",
                value: typeValue || "-",
                place: replace,
              },
              {
                title: "单" + centerReplace + "总量",
                value: resData.totalTraffic || "0",
                place: "GB",
              },
              {
                title: "当" + type + "剩余",
                value: resData.remainTraffic || "0",
                place: "GB",
              },
            ];
          }
        })
        .catch(() => {
          if (flage) {
            this.isLoading = false;
          }
        });
    },

    // 获取banner
    getBannerAction() {
      getBanner().then((res) => {
        this.bannerList = res.map((item) => {
          return {
            id: item.id,
            pic: item.pic,
            activityTheme: item.activityTheme,
            url: item.url,
          };
        });
      });
    },

    // 购买流量套餐
    buyTrafficPackage() {
      this.uni.navigateTo(
        "/home/updateBuy?sn=" + this.deviceSN + "&isShowOther=1&isenterAuth=0",
      );
    },

    // 购买流量套餐
    firstBuyTrafficPackage() {
      if (this.orderType === "L") {
        this.buyTrafficPackage();
      } else {
        if (this.tpIsNormal == 0) {
          this.buyTrafficPackage();
        } else {
          this.uni.navigateTo("/home/noDevice");
        }
      }
    },

    // 进入控制台
    enterInfor() {
      if (window.__wxjs_environment === "miniprogram") {
        // 小程序环境
        this.uni.navigateTo("/control/index");
      } else {
        this.uni.navigateTo("/home/deviceInfor?deviceSN=" + this.deviceSN);
      }
    },

    // 添加设备
    enterAddDevice() {
      this.uni.navigateTo("/home/addDevice");
    },

    // 进入用户中心
    enterCenterAction() {
      this.uni.navigateTo("/user/index");
    },

    // 进入实名认证
    enterAuth() {
      this.uni.navigateTo("/home/auth");
    },

    // 使用记录
    goUseList() {
      this.uni.navigateTo("/home/useList?id=" + this.deviceID);
    },

    // 上网认证
    goInternetAuth() {
      this.uni.navigateTo("/home/InternetAuthentication?sn=" + this.deviceSN);
      // this.uni.navigateTo("/home/InternetAuthList?sn=" + this.deviceSN);
    },
  },
};
</script>

<style lang="less" scoped>
.info-container {
  display: flex;
  flex-direction: column;
}

.auth-tip {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: var(--subs1-color);
  padding: 0 20px;

  .auth-left {
    display: flex;
    flex-direction: row;
    align-items: center;

    .left-img {
      width: 36px;
      height: 36px;
      border: 4px solid var(--primary-color);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 12px;
      box-sizing: border-box;
    }

    .left-text {
      font-size: 28px;
      color: var(--primary-color);
    }
  }

  .auth-right {
    display: flex;
    flex-direction: row;
    align-items: center;

    .right-text {
      font-size: 28px;
      color: var(--primary-color);
      margin-right: 4px;
    }
  }
}

.user-info-container {
  display: flex;
  align-items: center;
}

.user-head {
  width: 76px;
  height: 76px;
  margin: 20px 0 20px 32px;
  border-radius: 38px;
}

.user-info {
  font-size: 32px;
  color: #000;
  padding-left: 16px;
  flex: 1;
}

.user-info-right-icon {
  width: 32px;
  height: 32px;
  margin-right: 32px;
}

.user-info-line {
  width: 100%;
  height: 2px;
  background-color: #f5f6fa;
}

.enter-infor {
  display: flex;
  align-items: center;
  background-color: #f2f5fa;
  border-radius: 20px;
  margin-left: 32px;
  margin-right: 32px;
  margin-top: 32px;
  margin-bottom: 20px;
}

.enter-infor-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 112px;
  height: 112px;
  background-color: #d9dde1;
  border-radius: 12px;
  margin: 24px;
}

.enter-infor-image {
  width: 112px;
  height: 112px;
  object-fit: contain;
}

.enter-infor-text {
  margin-left: 4px;
}

.enter-infor-text-item {
  display: flex;
  align-items: center;
}

.enter-infor-text-item-title {
  font-size: 30px;
  color: #000;
  font-weight: bold;
  margin-bottom: 18px;
}

.enter-infor-text-item-status {
  font-size: 20px;
  color: #0fb176;
  margin: 0 12px 0 10px;
  background-color: #d6edea;
}

.enter-infor-color-block {
  background-color: #0fb176;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  margin-left: 10px;
}

.enter-infor-text-item-status-container {
  display: flex;
  align-items: center;
  background-color: #d6edea;
  margin-left: 20px;
  height: 32px;
  border-radius: 6px;
}

.enter-infor-text-item-number {
  font-size: 24px;
  color: var(--text-sub-color);
  margin-top: 2px;
}

.enter-infor-manger {
  display: flex;
  font-size: 28px;
  color: var(--primary-color);
  margin-left: auto;
}

.enter-infor-right-icon {
  display: flex;
  align-self: center;
  margin-right: 20px;
  align-items: center;
}

.item-container {
  display: flex;
  justify-content: space-between;
  margin-left: 32px;
  margin-right: 32px;
  margin-bottom: 16px;
  align-items: center;
}

.item {
  flex: 1;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.item-top-title {
  font-size: 30px;
  color: var(--primary-color);
  font-weight: bold;
  margin-bottom: 15px;
}

.item-bottom-title {
  font-size: 28px;
  color: var(--text-sub-color);
  margin-top: 0px;
}

.color-block {
  width: 100%;
  height: 10px;
  background-color: #f5f6fa;
  margin-top: 0px;
}

.traffic-statistics-content {
  display: flex;
  align-items: center;
  margin-left: 32px;
  margin-right: 32px;
}

.traffic-color-block {
  width: 6px;
  height: 24px;
  background-color: var(--primary-color);
}

.traffic-statistics-title {
  font-size: 32px;
  color: var(--text-color);
  font-weight: bold;
  margin-left: 16px;
}

.traffic-statistics-time {
  font-size: 24px;
  color: var(--text-sub-color);
  margin-left: auto;
  margin-right: 16px;
}

.traffic-icon {
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scaleX(-1) rotate(50deg);
}

.traffic-package-title {
  color: var(--primary-color);
  font: 28px;
  display: flex;
  justify-content: center;
}

.traffic-package-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  // margin-bottom: 15px;
}

.traffic-package-container.bottom-spacing {
  margin-bottom: 30px;
}

.traffic-package-info-container {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 10px;
  background-color: #f2f5fa;
  border-radius: 20px;
  margin-left: 32px;
  margin-right: 32px;
}

.traffic-package-info-item {
  flex: 1;
  text-align: center;
}

.traffic-time-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 32px 32px 32px;
}

.traffic-time-container.has-auth {
  flex-direction: column;
  align-items: stretch;
}

.traffic-time-container.has-auth .traffic-package-expire-time-content {
  margin-bottom: 16px;
}

.traffic-package-expire-time-title {
  font-size: 28px;
  color: var(--text-color);
  line-height: 1.4;
}

.traffic-package-conent {
  display: flex;
  gap: 25px;
  justify-content: space-between;
}

.traffic-conent {
  display: flex;
  gap: 25px;
  justify-content: space-between;
  margin: 32px;

  .package-one-left,
  .package-one-right {
    padding: 25px 0px;
    background-color: var(--primary-color);
    border: none;
    border-radius: 16px;
    color: white;
    white-space: nowrap;
    font-size: 30px;
    flex: 1;
  }
}

.traffic-package-one {
  padding: 25px 0px;
  background-color: var(--primary-color);
  border: none;
  border-radius: 16px;
  color: white;
  white-space: nowrap;
  font-size: 30px;
}

.traffic-package-auth-button,
.traffic-package-expire-time-button {
  padding: 25px 0px;
  background-color: var(--primary-color);
  border: none;
  border-radius: 16px;
  color: white;
  white-space: nowrap;
  font-size: 30px;
}

.traffic-package-button {
  padding: 16px 30px;
  background-color: var(--primary-color);
  border: none;
  border-radius: 8px;
  margin-left: auto;
  color: #f2f2f2;
  white-space: nowrap;
}

.traffic-package-conent,
.traffic-package-expire-time-button,
.traffic-package-auth-button {
  flex: 1;
}

.traffic-package-buy-button {
  background-color: var(--primary-color);
  border: none;
  border-radius: 20px;
  height: 90px;
  margin: 32px;
  color: #ffffff;
}

.log-buy-button {
  border: none;
  margin: 32px 32px 170px 32px;
  background-color: var(--primary-color);
  color: #fff;
  font-size: 32px;
  width: calc(100vw - 60px);
  height: 90px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 外面的整体灰色背景 */
.banner-wrapper {
  padding: 32px 32px 70px 32px; /* 让 Banner 四周留白 */
  background-color: var(--background-color);
}

/* Swipe 容器 */
.banner-swipe {
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 24px; /* 圆角变大，像图一样 */
}

/* 每张图片 */
.banner-image {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 24px; /* 图片也要同步圆角 */
  object-fit: cover;
}

.traffic-package-info-item-value {
  font: 40px;
  color: #000000;
  margin-bottom: 8px;
  font-weight: bold;
}

.traffic-package-info-item-title {
  font: 28px;
  color: var(--text-sub-color);
  margin-top: 0px;
}

.no-device-container {
  display: flex;
  align-items: center;
  margin: 32px;
  background-color: var(--subs1-color);
  border-radius: 20px;
  height: 160px;
  border: 2px dashed var(--primary-color);
  justify-content: center;
}

.no-device-text {
  color: var(--primary-color);
  font-size: 32px;
  font-weight: bold;
  margin-left: 20px;
}

.add-device-place {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--primary-color);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
